import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

// Filters of the inner variant list, over the same backend search item as the grouped list. `Name`
// is the list's scope rather than a typed filter, and the backend matches it exactly so a name
// containing this one ("Schedule D/E" vs "Schedule D/E Thanks") cannot leak in.
export default class TemplateVariantSearchParams extends SearchParamsBase {
  initialize() {
    this.Name = '';
    this.Locale = '';
    this.IsActive = '';
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'TemplateVariantSearchParams';

  static fieldsInSearchBox = [
    {
      fieldName: 'Locale',
      label: 'Language',
      className: 'col-6',
      type: InputTypesEnum.ApolloLanguageLocaleSelect,
    },
    {
      fieldName: 'IsActive',
      label: 'Is Active?',
      className: 'col-6',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
  ];
}
